import { render, staticRenderFns } from "./DevolucionesPantalla.vue?vue&type=template&id=46705328&"
import script from "./DevolucionesPantalla.vue?vue&type=script&lang=ts&"
export * from "./DevolucionesPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('46705328', component.options)
    } else {
      api.reload('46705328', component.options)
    }
    module.hot.accept("./DevolucionesPantalla.vue?vue&type=template&id=46705328&", function () {
      api.rerender('46705328', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Devoluciones/DevolucionesPantalla.vue"
export default component.exports